import axiosHttp from "services/axiosHttp";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BACKOFFICE_ORDER_REQUEST } from "../constants/apiPaths";

const configErrorMessage = (err, fallback) => {
	const d = err?.response?.data;
	if (typeof d === "string") return d;
	if (d?.message != null && typeof d.message === "string") return d.message;
	if (typeof d?.error === "string") return d.error;
	if (err?.message) return err.message;
	return fallback;
};

export const fetchOrderRequestConfig = createAsyncThunk(
	"orderRequests/fetchConfig",
	async ({ channelUuid } = {}, { rejectWithValue }) => {
		try {
			const response = await axiosHttp.get(`${BACKOFFICE_ORDER_REQUEST}/config/${channelUuid}`);
			const payload = response.data?.data ?? response.data;
			return payload;
		} catch (err) {
			return rejectWithValue(configErrorMessage(err, "Failed to fetch guardrail config"));
		}
	}
);

export const saveOrderRequestConfig = createAsyncThunk(
	"orderRequests/saveConfig",
	async ({ channelUuid, payload } = {}, { rejectWithValue }) => {
		const url = `${BACKOFFICE_ORDER_REQUEST}/config/${channelUuid}`;
		try {
			let response;
			try {
				response = await axiosHttp.post(url, payload);
			} catch (err) {
				if (err?.response?.status === 405) {
					response = await axiosHttp.patch(url, payload);
				} else {
					throw err;
				}
			}
			return response.data?.data ?? response.data;
		} catch (err) {
			return rejectWithValue(configErrorMessage(err, "Failed to save guardrail config"));
		}
	}
);

const OrderRequestConfigSlice = createSlice({
	name: "OrderRequestConfigSlice",
	initialState: {
		isLoading: false,
		isSaving: false,
		error: null,
		data: null,
	},
	extraReducers: (builder) => {
		builder
			.addCase(fetchOrderRequestConfig.pending, (state) => {
				state.isLoading = true;
				state.error = null;
			})
			.addCase(fetchOrderRequestConfig.fulfilled, (state, action) => {
				state.isLoading = false;
				state.data = action.payload;
			})
			.addCase(fetchOrderRequestConfig.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.payload || action.error?.message;
			})
			.addCase(saveOrderRequestConfig.pending, (state) => {
				state.isSaving = true;
				state.error = null;
			})
			.addCase(saveOrderRequestConfig.fulfilled, (state, action) => {
				state.isSaving = false;
				state.data = action.payload;
			})
			.addCase(saveOrderRequestConfig.rejected, (state, action) => {
				state.isSaving = false;
				state.error = action.payload || action.error?.message;
			});
	},
});

export default OrderRequestConfigSlice.reducer;
